import { appFormUtil } from 'modules/common';
import React from 'react';

export type IFormState = {
  email: string;
  code: string;
  isSent: boolean;
  password: string;
  isLoading: boolean;
  confirmPassword: string;
  step: number;
};

const initialState: IFormState = {
  email: '',
  code: '',
  password: '',
  confirmPassword: '',
  isSent: false,
  isLoading: false,
  step: 1
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      email: {
        label: 'Email',
        type: 'email',
        required: true
      },
      code: {
        label: 'Enter Code',
        type: 'text'
      },
      isLoading: {
        label: '',
        type: 'text'
      },
      step: {
        label: '',
        type: 'number'
      },
      password: {
        label: 'Password',
        type: 'password'
      },
      confirmPassword: {
        label: 'Confirm Password',
        type: 'password'
      },
      isSent: {
        label: '',
        type: 'text'
      }
    }
  });

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}
